import { render, staticRenderFns } from "./RelationContactPicker.vue?vue&type=template&id=011685d1"
import script from "./RelationContactPicker.vue?vue&type=script&lang=ts"
export * from "./RelationContactPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports